import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class UserAccountResource extends AuthenticatedResource {
  static urlRoot = '/user_accounts'

  readonly id: number | undefined = undefined;
  readonly name: string = '';
  readonly wallet_address: string = '';
  readonly preferred_language: string = '';
  readonly courses: Record<string, unknown>[] = [];
  readonly rewards: Record<string, unknown>[] = [];

  pk() {
    return 'userAccount';
  }
}